import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-hhg-rates-upload',
    templateUrl: './hhg-rates-upload.component.html',
    styleUrls: ['./hhg-rates-upload.component.css'],
    standalone: false
})

export class HhgRatesUploadComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {
  }
}
